import { render, staticRenderFns } from "./brokerInsuredDetail.vue?vue&type=template&id=8d76b758&scoped=true"
import script from "./brokerInsuredDetail.vue?vue&type=script&lang=js"
export * from "./brokerInsuredDetail.vue?vue&type=script&lang=js"
import style0 from "./brokerInsuredDetail.vue?vue&type=style&index=0&id=8d76b758&prod&scoped=true&lang=css"
import style1 from "./brokerInsuredDetail.vue?vue&type=style&index=1&id=8d76b758&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d76b758",
  null
  
)

export default component.exports